<template>
  <div class="completed-orders">
    <base-status-orders
      :status="'COMPLETED'"
      :title="'已完成订单'"
      :show-actions="false">
    </base-status-orders>
  </div>
</template>

<script>
import BaseStatusOrders from './BaseStatusOrders.vue'

export default {
  name: 'CompletedOrders',
  components: {
    BaseStatusOrders
  }
}
</script>

<style scoped>
.completed-orders {
  width: 100%;
  height: 100%;
  padding: 20px;
  box-sizing: border-box;
}

.order-form {
  width: 100%;
}

.form-title {
  margin-bottom: 30px;
  color: #303133;
  font-size: 20px;
  text-align: center;
}

.form-card {
  width: 100%;
  margin-bottom: 20px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
}

.form-card .el-card__header {
  padding: 15px 20px;
  border-bottom: 1px solid #ebeef5;
  font-weight: bold;
}

.el-form-item {
  margin-bottom: 22px;
  width: 100%;
}

.el-input,
.el-select,
.el-date-picker,
.el-radio-group,
.el-upload,
.el-textarea {
  width: 100%;
}

/* 两列布局 */
.form-row {
  display: flex;
  justify-content: space-between;
  margin: 0 -10px;
}

.form-col {
  flex: 1;
  padding: 0 10px;
}

/* 订单状态标签 */
.status-tag {
  padding: 5px 10px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: bold;
}

.status-tag.success {
  background-color: #f0f9eb;
  color: #67c23a;
}

/* 订单信息样式 */
.order-info {
  margin-bottom: 20px;
  padding: 15px;
  background-color: #f5f7fa;
  border-radius: 4px;
}

.info-item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.info-label {
  width: 120px;
  color: #606266;
  font-weight: bold;
}

.info-value {
  flex: 1;
  color: #303133;
}

/* 时间线样式 */
.order-timeline {
  margin-top: 30px;
  padding: 20px;
  background-color: #fff;
  border-radius: 4px;
}

.timeline-title {
  margin-bottom: 20px;
  font-size: 16px;
  font-weight: bold;
  color: #303133;
}

.el-timeline-item__content {
  color: #606266;
}

.timeline-time {
  font-size: 12px;
  color: #909399;
}

.timeline-status {
  font-weight: bold;
  color: #67c23a;
}

/* 备注信息样式 */
.remark-info {
  margin-top: 20px;
  padding: 15px;
  background-color: #fdf6ec;
  border-radius: 4px;
  color: #e6a23c;
}
</style> 